export class SearchItem {
  name:string
  action: Function
  selected : boolean = false;
  shortcutId : string;
  opensFileExplorer: boolean = false;
}
